import { useSharedAPI } from "@certn/api";
import { useMemo } from "react";

import { SearchableSelectControl } from "./SearchableSelectControl";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function CountrySelectControl(props: CascadiaControlProps) {
  const { data: countryList, isLoading } = useSharedAPI(
    "/api/internal/shared/countries/"
  );

  const sortedCountryList = useMemo(
    () => countryList?.sort((a, b) => a.name.localeCompare(b.name)),
    [countryList]
  );

  const mappedCountryList = useMemo(
    () =>
      sortedCountryList?.map((country) => {
        return { label: country.name, value: country.alpha_2 };
      }),
    [sortedCountryList]
  );

  return (
    <SearchableSelectControl
      {...props}
      items={mappedCountryList || []}
      required={Boolean(sortedCountryList?.length && props.required)}
      isLoading={isLoading}
    />
  );
}

CountrySelectControl.displayName = "CountrySelectControl";

export const CountrySelectRenderer =
  withCascadiaControlProps(CountrySelectControl);
